import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {
  CitizensServicesExistanceSource,
  filteringInputExistanceSource
} from './citizens-services-existance-source.model';

export const loadCitizensServicesExistanceSources = createAction(
  '[CitizensServicesExistanceSource/API] Load CitizensServicesExistanceSources',
  props<{ citizensServicesExistanceSources: CitizensServicesExistanceSource[] }>()
);

export const addCitizensServicesExistanceSource = createAction(
  '[CitizensServicesExistanceSource/API] Add CitizensServicesExistanceSource',
  props<{ citizensServicesExistanceSource: CitizensServicesExistanceSource }>()
);

export const upsertCitizensServicesExistanceSource = createAction(
  '[CitizensServicesExistanceSource/API] Upsert CitizensServicesExistanceSource',
  props<{ citizensServicesExistanceSource: CitizensServicesExistanceSource }>()
);

export const addCitizensServicesExistanceSources = createAction(
  '[CitizensServicesExistanceSource/API] Add CitizensServicesExistanceSources',
  props<{ citizensServicesExistanceSources: CitizensServicesExistanceSource[] }>()
);

export const upsertCitizensServicesExistanceSources = createAction(
  '[CitizensServicesExistanceSource/API] Upsert CitizensServicesExistanceSources',
  props<{ citizensServicesExistanceSources: CitizensServicesExistanceSource[] }>()
);

export const updateCitizensServicesExistanceSource = createAction(
  '[CitizensServicesExistanceSource/API] Update CitizensServicesExistanceSource',
  props<{ citizensServicesExistanceSource: Update<CitizensServicesExistanceSource> }>()
);

export const updateCitizensServicesExistanceSources = createAction(
  '[CitizensServicesExistanceSource/API] Update CitizensServicesExistanceSources',
  props<{ citizensServicesExistanceSources: Update<CitizensServicesExistanceSource>[] }>()
);

export const deleteCitizensServicesExistanceSource = createAction(
  '[CitizensServicesExistanceSource/API] Delete CitizensServicesExistanceSource',
  props<{ id: string }>()
);

export const deleteCitizensServicesExistanceSources = createAction(
  '[CitizensServicesExistanceSource/API] Delete CitizensServicesExistanceSources',
  props<{ ids: string[] }>()
);

export const clearCitizensServicesExistanceSources = createAction(
  '[CitizensServicesExistanceSource/API] Clear CitizensServicesExistanceSources'
);

//CUSTOM

export const citizenGetServicesExistanceSource = createAction(
  '[CitizensServicesExistanceSource/API] citizen Get Services Existance Source',
  props<{ filtering: filteringInputExistanceSource }>()
);
